import React from "react";
import { NavLink } from "react-router-dom";
import "../../stylesheets/resource.scss";

//--------------------
//Search filter Status
export const SelectOptions = [
	{
		value: 0,
		label: "Pending",
	},
	{
		value: 1,
		label: "InProgress",
	},
	{
		value: 2,
		label: "Completed",
	},
	{
		value: 3,
		label: "Rejected",
	},
];
//----------------------
//Search filter Priority
export const SelectOptionsPriority = [
	{
		value: 0,
		label: "High",
	},
	{
		value: 1,
		label: "Medium",
	},
	{
		value: 2,
		label: "Low",
	},
];

//---------------------------
//Search filter ProjectStatus
export const AllocateTeam = (cell) => {
	if (cell == null) {
		return "N/A";
	} else {
		const title = cell.map((allocate) => allocate.name).join(",");
		return (
			<div className="team" title={title}>
				{title.substring(0, 30)}
			</div>
		);
	}
};

//-------
//Spinner
export const Loader = () => <div className="mt-4"></div>;
//----------
//No data
export const NoDataIndication = () => (
	<div className="font-weight-bold mt-4">
		<span>NO RECORD FOUND</span>
	</div>
);
//-----------
//Date Column
export const dateCol = (cell) => {
	let dateObj = cell;
	if (cell === null) {
		return;
	}
	if (cell !== "date") {
		dateObj = new Date(cell);
	}
	return `${("0" + dateObj.getDate()).slice(-2)}/${(
		"0" +
		(dateObj.getMonth() + 1)
	).slice(-2)}/${dateObj.getFullYear()}`;
};
//--------
//Priority
export const ticketPriority = (cell) => {
	if (cell === 0) {
		return "High";
	}
	if (cell === 1) {
		return "Medium";
	}
	if (cell === 2) {
		return "Low";
	}
};
//------
//Status
export const ticketStatus = (cell) => {
	if (cell === 0) {
		return "Pending";
	}
	if (cell === 1) {
		return "InProgress";
	}
	if (cell === 2) {
		return "Completed";
	}
	if (cell === 3) {
		return "Rejected";
	}
};
//------
//Status
export const ProjectStatus = (row) => {
	if (row === 0) {
		return <span className="inactive">Inactive</span>;
	}
	if (row === 1) {
		return <span className="active">Active</span>;
	}
};

export const options = {
	paginationSize: 1,
	pageStartIndex: 1,
	hideSizePerPage: true,
	sizePerPage: 30,
	withFirstAndLast: false,
	prePageText: "Prev",
	nextPageText: "Next",
	disablePageTitle: true,
};
//------------
//Pagination for Bug report page
export const bugOptions = {
	paginationSize: 1,
	pageStartIndex: 1,
	hideSizePerPage: true,
	sizePerPage: 10,
	withFirstAndLast: false,
	prePageText: "Prev",
	nextPageText: "Next",
	disablePageTitle: true,
};
//------------
//table layout
export const tableStyle = (row, rowIndex, cell) => {
	const style = {};
	if (rowIndex % 2 === 0) {
		style.backgroundColor = "#E5F7F6";
	} else {
		style.backgroundColor = " #F2FBFA";
	}
	if (row) {
		style.color = "#43A3A5";
	}
	return style;
};
//---------------------
// Project History View
export const mystyle = {
	color: "#009999",
	fontWeight: "Bold",
	fontSize: "Larger",
};
export const expandRow = {
	className: "expandingRow",
	onlyOneExpanding: true,
	showExpandColumn: true,
	expandByColumnOnly: true,
	renderer: (row) => (
		<div>
			<label for="p1" style={mystyle}>
				Project Name
			</label>
			<p id="p1">{row.itemName}</p>
			<label for="p2" style={mystyle}>
				Project Type
			</label>
			<p id="p2">{row.department}</p>
			<label for="p3" style={mystyle}>
				Supervisor
			</label>
			<p id="p3">{row.priority}</p>
			<label for="p4" style={mystyle}>
				Allocate To
			</label>
			<p id="p4">{row.assignee}</p>
			<label for="p5" style={mystyle}>
				Status
			</label>
			<p id="p5">
				{row.status === 0
					? "Pending"
					: row.status === 1
					? "InProgress"
					: row.status === 2
					? "Completed"
					: row.status === 3
					? "Rejected"
					: row.status}
			</p>
			<label for="p7" style={mystyle}>
				Notes
			</label>
			<p id="p7">{row.department}</p>
			<label for="p6" style={mystyle}>
				Update Date
			</label>
			<p id="p6">{new Date(row.requestDate).toDateString()}</p>
		</div>
	),
};
//-----------------------------------
//-----------------------------------
export const titleAssigned = () => {
	return (
		<>
			<div className="row">
				<div className="mt-2 mt-lg-0 mt-md-0">
					<NavLink
						className="inActiveHeaderButtonStyle"
						to="CountryManagerTicketListing"
					>
						All Department Tickets
					</NavLink>
				</div>
				<div className="mt-2 mt-lg-0 mt-md-0">
					<NavLink
						className="activeHeaderButtonStyle"
						to="CMAssignedTickets"
					>
						View Assigned Tickets
					</NavLink>
				</div>
			</div>
		</>
	);
};
//-----------------------------------
//-----------------------------------
export const titleAll = () => {
	return (
		<>
			<div className="row">
				<div className="mt-2 mt-lg-0 mt-md-0">
					<NavLink
						className="activeHeaderButtonStyle"
						to="CountryManagerTicketListing"
					>
						All Department Tickets
					</NavLink>
				</div>
				<div className="mt-2 mt-lg-0 mt-md-0">
					<NavLink
						className="inActiveHeaderButtonStyle"
						to="CMAssignedTickets"
					>
						View Assigned Tickets
					</NavLink>
				</div>
			</div>
		</>
	);
};
//----------------------------------
//Match Function
export function customMatchFunc({ searchText, value, column, row }) {
	if (typeof value !== "undefined") {
		return value.startsWith(searchText);
	}
	return false;
}
//time col
export const timeCol = (cell) => {
	const timeSpan = cell?.split(":");
	return timeSpan ? timeSpan[0] + ":" + timeSpan[1] : null;
};

//office hours Table style
export const officeHoursTableStyle = (row, rowIndex, cell) => {
	const { checkedOutAt, checkedInAt, status } = row;
	const style = {};
	if (checkedOutAt === null && checkedInAt) {
		style.backgroundColor = "rgb(300, 232, 232)";
	} else if (status === "Late") {
		style.color = "red";
		style.backgroundColor = "rgb(300, 232, 232)";
	} else if (rowIndex % 2 === 0) {
		style.backgroundColor = "#E5F7F6";
	} else {
		style.backgroundColor = "#F2FBFA";
	}
	if (row) {
		style.color = "#43A3A5";
	}
	return style;
};
//Excel Button
export const ExcelBtnTitle = "Export to Excel";
export const ExcelBtnClassName = "d-flex exportExcel-btn";
export const SendEmailBtnTitle = "Send Emails and execute deductions";
export const SendEmailClassName = "d-flex exportExcel-btn";
